import Api from '../../../../../../shared/Api';

// TODO: This will change...
export type ICustomerImage = {
    id: number;
    filename: string;
    highResolutionImageReference: string;
    reference: string;
    previewReference: string;
    orderRowName: string;
    orderRowId: number;
    hasUploadedNormal: boolean;
    hasAutoScale: boolean;
    highResolutionWidth: number;
    highResolutionHeight: number;
    isCustomerApproved: boolean;
};

export type CustomerDigitalStylingResponse = {
    orderStatus: {
        displayName: string;
        value: number;
    };
    images: ICustomerImage[];
    hasNormalResolutionImagesAvailable: boolean;
};

export class CustomerDigitalStylingApi {
    static getData(orderId: number): Promise<CustomerDigitalStylingResponse> {
        return new Api().get(`/views/digital-styling/${orderId}`);
    }

    static getCustomerFiles(orderId: number) {
        return new Api().get(`/views/digital-styling-upload/${orderId}/customer-files`);
    }

    static deleteSingleImage(imageId: number) {
        return new Api().delete(`/views/digital-styling-upload/customer-files/${imageId}`);
    }

    static deleteMultipleImages(imageIds: number[]) {
        return new Api().post(`/views/digital-styling-upload/customer-files/delete-multiple`, {
            customerFileIds: imageIds
        });
    }

    static downloadHighResolutionImages(orderId: number) {
        return new Api().get(`/views/digital-styling/download/high-resolution/${orderId}`);
    }

    static downloadNormalResolutionImages(orderId: number) {
        return new Api().get(`/views/digital-styling/download/normal-resolution/${orderId}`);
    }

    static sendInMaterial(orderId: number) {
        return new Api().post(
            `/views/digital-styling-upload/${orderId}/customer-files/send-in`,
            {}
        );
    }
    
    static sendInWithoutMaterial(orderId: number) {
        return new Api().post(
            `/views/digital-styling-upload/${orderId}/customer-files/send-in-no-files`,
            {}
        );
    }
}
